<template>
  <div id="app">
    <logs-table/>
  </div>
</template>

<script>
import LogsTable from './pages/LogsTable';

export default {
    name: 'App',
    components: {
        LogsTable
    }
};
</script>



// WEBPACK FOOTER //
// src/App.vue